export default __webpack_public_path__ + "static/media/David Amachree.aad97dfd.jpg";